import { produce } from 'immer';
import { drama } from '../../../constants/actionTypes';

const initState = {};

export default produce((draft, action) => {
  switch (action.type) {
    case drama.FETCH_DRAMAINFO_SUCCESS: {
      draft[action.payload.id] = action.payload.data;
      break;
    }
  }
}, initState);
